/**
 * The emote wheel's words that are not the emote table's (P2.19-T8; ADR-114 decision 1.4). The author accepted these, and
 * the action's name "Emotes", on 2026-10-08, and chose `typing`'s "Typing" the same day. The pages' names, the words on
 * the entries and the sentences an action sends are the emote table's.
 */
export const WHEEL = {
  wheel: "Emote wheel",
  pageBefore: "Page before",
  pageAfter: "Page after",
  send: "Send",
  close: "Close",
  typing: "Typing",
} as const;
